import React, { useEffect, useState, useRef } from 'react';
import usePermissions from 'hooks/usePermissions';
import { useNavigate, Link } from 'react-router-dom';
import moment from 'moment';
import { Skeleton } from '@mui/material';
import { TbDatabaseExclamation } from 'react-icons/tb';
import useIsMobile from 'utils/isMobileUtils';
import { FaSearch } from 'react-icons/fa';
import StatusBadge from 'ui-component/StatusBadge';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import NoItemFound from 'assets/images/no-item-found.svg'

// ✅ Clear
const WarehouseStockLists = ({
    id,
}) => {

    const [allPermissions, hasEveryPermission] = usePermissions();
    const [isLoading, setIsLoading] = useState(true);

    const [searchField, setSearchField] = useState();
    const [searchValue, setSearchValue] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);

    
    const handleSearch = (e) => {
        

        let text = e.target.value;
        
        setIsLoading(true);
        setSearchValue(text);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only update searchField after user stops typing for 500ms
        let timeout = setTimeout(() => {
            setSearchField(text)	
        }, 500);

        setSearchTimeout(timeout);
    };
    const isMobile = useIsMobile();

    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const tableRef = useRef();
    const [showPreloadingRows, setShowPreloadingRows] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);

    const [sortByFilter, setSortByFilter] = useState();


    const initializeData = () => {
        // Initial load
        let request = {}
        request.page = 1;
        request.search = searchField?.length > 2 ? searchField : null;


        api.getWarehouseDetailsWithStocks(id, request, searchField, sortByFilter).then((res) => {

            setDataList([]);
            setTimeout(() => {
                setDataList(res?.data?.data?.data || []);

                setHasMore(true);
                setPage(1);
                setIsLoading(false);
                setShowPreloadingRows(false);
                setTotalRecords(res?.data?.data?.total || 0);
            }, 300);
        });

    }


    useEffect(() => {
        // Only run fetchData after user stops typing (debounced by searchTimeout)
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeout = setTimeout(() => {
            const fetchData = async () => {
                // if (storedSearch) {
                //     await handleSearch({ target: { value: storedSearch } });
                // }
                setDataList([]);
                initializeData();
            };
            fetchData();
        }, 500); // 500ms debounce

        setSearchTimeout(timeout);

        // Cleanup on unmount or before next effect run
        return () => clearTimeout(timeout);
        // Only trigger when these change
    }, [searchField]); //storedSearch, 


    useEffect(() => {
        const handleScroll = () => {
            if (!tableRef.current || showPreloadingRows || !hasMore) return;
            const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
            // Trigger only when user reaches the bottom (with a small threshold)
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                loadMoreData();
            }
        };
        const currentRef = tableRef.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [showPreloadingRows, hasMore, dataList]);


    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getWarehouseDetailsWithStocks(id, request, searchField, sortByFilter).then((res) => {
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };




    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12">

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 10,
                        paddingTop: 0,
                        paddingBottom: 5,
                        paddingLeft: 20,
                        paddingRight: 20
                    }}
                    className="show-on-mobile"
                >
                    <form className="form-inline navbar-search" style={{ flex: 1 }}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <input
                                type="text"
                                className="form-control bg-white border"
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="basic-addon2"
                                value={searchValue || ''}
                                onChange={handleSearch}
                                style={{ width: '100%', paddingRight: 36 }}
                            />
                            <span
                                className="searchIcon"
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#888',
                                    pointerEvents: 'none'
                                }}
                            >
                                <FaSearch />
                            </span>
                        </div>
                    </form>
                </div>
                <div className={`${isMobile ? 'admin-shorter-table' : 'mt-1'}`}>
                    <div
                        className=" align-items-center justify-content-between TableSerachBar absolute"
                            style={{
                                position: 'absolute',
                                marginTop: '-40px',
                                right: '12px',
                                padding: 0
                            }}
                    >
                        
                        <form className="form-inline navbar-search" onSubmit={(e) => e.preventDefault()}>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control bg-white border"
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon2"
                                    onChange={handleSearch}
                                    style={{ width: '100%' }}
                                    value={searchValue || ''}
                                />
                                <span className="searchIcon">
                                    <FaSearch />
                                </span>
                            </div>
                        </form>
                    </div>
                    {!isMobile ? (
                        <div
                            className="table-responsive-xl tableData estimationList"
                            ref={tableRef}
                            style={{
                                height: 'calc(100vh - 345px)',
                                overflowY: 'auto',
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#0966ff transparent',
                                marginTop: '5px'

                            }}
                        >
                            <table className="table pm-table" style={{ marginTop: '1px' }}>
                                <thead>
                                    <tr className="sticky-header">
                                        <th scope="col">Product</th>
                                        <th scope="col text-left" style={{ width: '150px' }}>Color</th>
                                        <th scope="col text-left" style={{ width: '80px' }}>Qty</th>
                                        <th scope="col text-left" style={{ width: '103px' }}>Reserved Qty</th>
                                        <th scope="col text-left" style={{ width: '90px' }}>Price</th>
                                        <th scope="col text-left" style={{ width: '115px' }}>Stock Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        [...Array(100)].map((e, i) => (
                                            <tr height="50px">
                                                <td>
                                                    <div className="flex gap-3 align-items-center">
                                                        <div style={{ width: '50px', height: '50px' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={50} style={{ borderRadius: '12px' }} />
                                                        </div>
                                                        <div className="w-full">
                                                            <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} />
                                                        </div>
                                                    </div>
                                                </td>
                                                <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                            </tr>
                                        ))
                                    ) : (
                                        <>
                                            {dataList?.length > 0 && (
                                                dataList?.map((row, index) => {
                                                    return (
                                                        <tr key={index} className="hover-row" height="50px">
                                                            <td
                                                                className="align-middle font500 text-primary"
                                                                style={{
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                
                                                                <div className="flex gap-3 align-items-center">
                                                                    <div style={{ width: '50px', height: '50px' }}>
                                                                        {
                                                                            row?.thumbnail?.thumbnail_url ? (
                                                                                <img src={row?.thumbnail?.thumbnail_url} style={{ width: '30px', height: '50px' }} alt="product" />
                                                                            ) : (
                                                                                <img src={NoItemFound} style={{ width: '30px' }} alt="nproduct" />
                                                                            )
                                                                        }
                                                                    </div>
                                                                    <div className="w-full">
																	{
																		(hasEveryPermission(['View Product (Button)'])) ? (
																			<Link to={`/products/${row.product_id}`} className="text-gray-900">
                                                                                {row?.product_name}
																			</Link>
																		) : (
																			row?.product_name
																		)
																	}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="align-middle">
                                                                {
                                                                    row?.color_name ? (
                                                                        row?.color_name 
                                                                    ) : (
                                                                        <span className="text-gray-500">No Color</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td className="align-middle">
                                                                {
                                                                    row?.stocks?.total > 0 ? (
                                                                        row?.stocks?.total
                                                                    ) : (
                                                                        <span className="text-gray-500">0</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td className="align-middle">
                                                                {
                                                                    row?.stocks?.reserved > 0 ? (
                                                                        row?.stocks?.reserved
                                                                    ) : (
                                                                        <span className="text-gray-500">0</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td className="align-middle">
                                                                {
                                                                    row?.stocks?.price > 0 ? (
                                                                        `$${row?.stocks?.price}`
                                                                    ) : (
                                                                        <span className="text-gray-500">$0.00</span>
                                                                    )
                                                                }
                                                            </td>
                                                            <td className="align-middle">
                                                                {
                                                                    row?.stocks?.price > 0 ? (
                                                                        `$${row?.stocks?.stock_value}`
                                                                    ) : (
                                                                        <span className="text-gray-500">$0.00</span>
                                                                    )
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                            {showPreloadingRows && (
                                                [...Array(100)].map((e, i) => (
                                                    <tr height="50px">
                                                        <td>
                                                            <div className="flex gap-3 align-items-center">
                                                                <div style={{ width: '50px', height: '50px' }}>
                                                                    <Skeleton variant="rounded" width={'100%'} height={50} style={{ borderRadius: '12px' }} />
                                                                </div>
                                                                <div className="w-full">
                                                                    <Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} />
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                        <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                        <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                        <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                        <td><Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '12px' }} /></td>
                                                    </tr>
                                                ))
                                            )}
                                            {(dataList?.length < 1 && !isLoading) && (
                                                <tr className="no-hover">
                                                    <td colSpan={6} className="whitebg">
                                                        <div className="not-found-container">
                                                            <div className="not-found-icon">
                                                                <img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
                                                            
                                                            </div>
                                                            <h6 className="not-found-text">No Data Available</h6>

                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div
                            className="picklists-mobile-list"
                            ref={tableRef}
                            style={{
                                height: `calc(100dvh - 610px)`,
                                overflowY: 'auto',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            {isLoading ? (
                                [...Array(7)].map((_, i) => (
                                    <div className="inv-cards-list d-md-none" style={{ padding: '12px 0' }}>
                                        {[...Array(15)].map((_, idx) => (
                                            <div
                                                key={idx}
                                                className="order-list-card"
                                                style={{
                                                    background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
                                                    marginBottom: 10,
                                                    borderRadius: 12,
                                                    padding: 16,
                                                    minHeight: 90,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 10
                                                }}
                                            >
                                                {[...Array(3)].map((__, i) => (
                                                    <div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            ) : (
                                <>
                                    {dataList.map((row, index) => (
                                      
                                        <div
                                            key={index}
                                            className="mobile-product-card"
                                            style={{
                                                borderBottom: '1px solid #eee',
                                                padding: '10px 20px',
                                                background: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: 12,
                                                width: '100%'
                                            }}
                                            onClick={() => {
                                                if (hasEveryPermission(['View Product (Button)'])) {
                                                    viewData(row.id);
                                                }
                                            }}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ fontWeight: 600, fontSize: 13 }}>{row?.product_name}</div>
                                                <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                                    <div style={{ color: '#888', fontSize: 13 }}>Color: {row?.color_name ?? 'No Color'}</div>
                                                </div>{' '}
                                                <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                                    <div style={{ color: '#888', fontSize: 13 }}>Total Qty: {row?.stocks?.total}</div>
                                                    <div className="text-gray-700">|</div>
                                                    <div style={{ color: '#888', fontSize: 13 }}>Reserved Qty: {row?.stocks?.reserved}</div>
                                                </div>{' '}
                                                <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                                    <div style={{ color: '#888', fontSize: 13 }}>Price: {`$${row?.stocks?.price}`}</div>
                                                    <div className="text-gray-700">|</div>
                                                    <div style={{ color: '#888', fontSize: 13 }}>Stock Value: {`$${row?.stocks?.stock_value}`}</div>
                                                </div>{' '}
                                            </div>
                                            <div>
                                                 {
                                                    row?.thumbnail?.thumbnail_url ? (
                                                        <img src={row?.thumbnail?.thumbnail_url} style={{ width: 'auto', height: 60, objectFit: 'cover', borderRadius: 8 }} alt="product" />
                                                    ) : (
                                                        <img src={NoItemFound} style={{ width: 'auto', height: 60, objectFit: 'cover', borderRadius: 8 }} alt="nproduct" />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))}
                                
                                    {showPreloadingRows && (
                                        [...Array(100)].map((_, idx) => (
                                            <div
                                                key={idx}
                                                className="order-list-card"
                                                style={{
                                                    background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
                                                    marginBottom: 10,
                                                    borderRadius: 12,
                                                    padding: 16,
                                                    minHeight: 90,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 10
                                                }}
                                            >
                                                {[...Array(3)].map((__, i) => (
                                                    <div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
                                                        <Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
                                                    </div>
                                                ))}
                                            </div>
                                        ))
                                    )}
                                    {(dataList?.length < 1 && !isLoading) && (
                                        <div className="w-100">
                                            <div className="not-found-container">
                                                <div className="not-found-icon">
                                                    <TbDatabaseExclamation />
                                                </div>
                                                <h6 className="not-found-text">No Data Available</h6>

                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}

                    <div
                        className="hide-on-mobile"
                        style={{
                            padding: '10px 0px 10px 20px',
                            borderTop: '1px solid #e0e0e0e0',
                            display: 'flex',
                            gap: '5px',
                            justifyContent: 'space-between',
                            height: '45px',
                        }}
                    >

                        <div className="flex align-items-center" style={{ gap: '10px' }}>
                        
                        </div>
                        <div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
                            {isLoading ? (
                                <div style={{ width: '100px' }}>
                                    <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                </div>
                            ) : (
                                <>
                                    <div className="text-gray-800">Total Record:</div>
                                    <div className="fw-500">
                                        {totalRecords.toLocaleString('en-US')}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default WarehouseStockLists;
